var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flash-message-cover"},[_c('div',{staticClass:"flash-message",class:_vm.type},[_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.getMessage()))]),_c('button',{staticClass:"close",attrs:{"id":"close-btn"},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('flash_message_close_button')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }